import * as graphqlService from './graphqlService';
export * from './graphqlService';

export default graphqlService;